import React from "react";

const ChronologyData = () => (
  <>
    <br />
    <table width="100%" border="1" cellspacing="0" cellpadding="5" bordercolor="#993300">
      <tr align="left" valign="top">
        <td width="24%" class="text">1771</td>
        <td width="24%" class="text">January 17</td>
        <td width="76%" class="text">Born 17 January to Elijah (b. 1740)
          and Mary Armitt Brown</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1777</td>
        <td width="24%" class="text">September</td>
        <td width="76%" class="text">Elijah Brown, Sr. exiled to Virginia
          by American (and later British) authorities for refusal to participate
          in the revolution (Kafer)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1778</td>
        <td width="24%" class="text">April</td>
        <td width="76%" class="text">Elijah Brown returns from exile (Kafer)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1781</td>
        <td width="24%" class="text">&nbsp;</td>
        <td width="76%" class="text">enters Friends' Latin School, Philadelphia
          (Kennedy)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1786</td>
        <td width="24%" class="text">&nbsp;</td>
        <td width="76%" class="text">earliest extant writing, the poem
          "On Some of His School Fellows" (Kennedy)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1787</td>
        <td width="24%" class="text">&nbsp;</td>
        <td width="76%" class="text">begins law study with Alexander Wilcocks
          forms "Belles Lettres Club" with eight friends</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1788</td>
        <td width="24%" class="text">&nbsp;</td>
        <td width="76%" class="text">writes Henrietta letters, basis
          for projected epistolary novel (Brown, 19 May 1792)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1789</td>
        <td width="24%" class="text">&nbsp;</td>
        <td width="76%" class="text">Wilcocks named recorder of Philadelphia</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text"> Spring</td>
        <td width="76%" class="text">meets William Wood Wilkins; introduces
          him to Club</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">August</td>
        <td width="76%" class="text">First installment of &quot;The Rhapsodist,&quot;
          <span class="textitalic">Columbian Magazine</span></td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">September</td>
        <td width="76%" class="text">Second installment of &quot;The Rhapsodist,&quot;
          <span class="textitalic">Columbian Magazine</span></td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">October</td>
        <td width="76%" class="text">Third installment of &quot;The Rhapsodist,&quot;
          <span class="textitalic">Columbian Magazine</span></td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">November</td>
        <td width="76%" class="text">Fourth installment of &quot;The Rhapsodist,&quot;
          <span class="textitalic">Columbian Magazine</span></td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1790</td>
        <td width="24%" class="text">&nbsp;</td>
        <td width="76%" class="text">Elihu Hubbard Smith moves to Philadelphia;
          Brown meets him sometime before his return to New York in 1791;
          Brown helps form Society for the Attainment of Useful Knowledge</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">December</td>
        <td width="76%" class="text">death of John Davidson</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1792</td>
        <td width="24%" class="text">&nbsp;</td>
        <td width="76%" class="text">gives up law study; begins writing
          &quot;Julius&quot; (Brown 19 May 1792)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">October</td>
        <td width="76%" class="text">Wilkins moves to Trenton (Clark 24);
          Brown visits Wilkins in Trenton (Brown, n.d.; Wilkins 25 December
          1792)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1793</td>
        <td width="24%" class="text">April 8</td>
        <td width="76%" class="text">Wilkins moves to Woodbury, NJ (Kennedy;
          Brown 4 May 1793)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">May 22</td>
        <td width="76%" class="text">Brown arrives Litchfield, CT to visit
          E.H. Smith; remains three months (Brown 22 May 1793)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">Summer</td>
        <td width="76%" class="text">Yellow fever epidemic in Philadelphia</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">December</td>
        <td width="76%" class="text">Bringhurst moves to Wilmington, Delaware
          (Brown 20 December 1793)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1794</td>
        <td width="24%" class="text">April 24</td>
        <td width="76%" class="text">sees performance of Dunlap's <span class="textitalic">Fatal
          Deception</span>, New York (Brown 28 November 1794)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">Summer</td>
        <td width="76%" class="text">visits Elihu Hubbard Smith in New
          York (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">August 31</td>
        <td width="76%" class="text">back in Philadelphia, has noon meal
          at home of Henry & Elizabeth Drinker with T.C. Cope and Benjamin
          Wilson (Drinker)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">September</td>
        <td width="76%" class="text">writes poem &quot;Devotion: An Epistle&quot;
          to Deborah Ferris (Ferris)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">Fall</td>
        <td width="76%" class="text">teaches at Friends' School in Philadelphia?
          (Warfel 44-45, Clark 108)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1795<br />
        </td>
        <td width="24%" class="text">February 15</td>
        <td width="76%" class="text">Wilkins dies of tuberculosis</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">April 5</td>
        <td width="76%" class="text">visits "John Eckstein & Sons exhibit
          room" with Deborah Ferris, Ruth Paxson, Mary Attmore</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">Summer</td>
        <td width="76%" class="text">visits Smith in New York (Bringhurst
          15 June 1795) and Dunlap in Perth Amboy, NJ (Ferris 4 September
          1795)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">September 3</td>
        <td width="76%" class="text">returns to Philadelphia (Ferris 4
          September 1795; Smith 7 September)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">September</td>
        <td width="76%" class="text">begins writing "Philadelphia Novel"
          (probably Arthur Mervyn; Brown September 1795)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1796</td>
        <td width="24%" class="text">late July</td>
        <td width="76%" class="text">moves to Perth Amboy to visit Dunlap
          (Smith 24 July 1796)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">Summer</td>
        <td width="76%" class="text">brother Joseph Brown marries and
          moves to New York (Brown 1 September 1796)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">August</td>
        <td width="76%" class="text">moves to New York through March,
          1797 (Smith 31 August 1796)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">September 10</td>
        <td width="76%" class="text">attends Friendly Club at Dunlap's
          (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">September 24</td>
        <td width="76%" class="text">attends Friendly Club (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">October 3</td>
        <td width="76%" class="text">sees <span class="textitalic">Road
          to Ruin</span> and <span class="textitalic">The Spoiled Child</span>
          at the theatre (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">October 31</td>
        <td width="76%" class="text">sees premiere of Dunlap's <span class="textitalic">The
          Mysterious Monk</span> and <span class="textitalic">The Midnight
            Hour </span>(Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">November 12</td>
        <td width="76%" class="text">attends Friendly Club at Woolsey's
          (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">November 19</td>
        <td width="76%" class="text">attends Friendly Club at Smith's
          (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">November 26</td>
        <td width="76%" class="text">attends Friendly Club at Kent&#146;s
          (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">November 30</td>
        <td width="76%" class="text">sister Elizabeth Brown marries, Stacy
          Horner of Burlington, New Jersey (Genealogical Records)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">December 3</td>
        <td width="76%" class="text">attends Friendly Club at Dunlap's
          (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">December 10</td>
        <td width="76%" class="text">attends Friendly Club at Johnson's
          (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">December 17</td>
        <td width="76%" class="text">attends Friendly Club at William
          Woolsey's (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">December 24</td>
        <td width="76%" class="text">attends Friendly Club at George Woolsey's
          (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">December 31</td>
        <td width="76%" class="text">attends Friendly Club at Smith's
          (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1797</td>
        <td width="24%" class="text">January 7</td>
        <td width="76%" class="text">attends Friendly Club at Dunlap's
          (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">January 12-16</td>
        <td width="76%" class="text">James Brown visits (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">January 14</td>
        <td width="76%" class="text">attends Friendly Club at Smith's
          (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">March 11</td>
        <td width="76%" class="text">attends Friendly Club at Smith's
          (Smith; Club had not met since January)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">March 16</td>
        <td width="76%" class="text">leaves for Philadelphia (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">April-May</td>
        <td width="76%" class="text">Smith visits Brown in Philadelphia
          (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1798</td>
        <td width="24%" class="text">February 3</td>
        <td width="76%" class="text">first issue of <span class="textitalic">Weekly
          Magazine</span></td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">March</td>
        <td width="76%" class="text">tells Smith he is "in love" with
          Susan Potts (Dunlap 29 March)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">March-April</td>
        <td width="76%" class="text"><span class="textitalic">Alcuin</span>
          published</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">April 11-13</td>
        <td width="76%" class="text">Dunlap visits Brown in Philadelphia;
          reads Brown's <span class="textitalic">Sky-Walk</span> (Dunlap)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">June</td>
        <td width="76%" class="text">visits brother James in Princeton
          (Dunlap 3 July 1798)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July 3</td>
        <td width="76%" class="text">arrives at New York; remains through
          September 24 (Dunlap 3 July 1798)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July 19</td>
        <td width="76%" class="text">attends constitutory meeting of American
          Mineralogical Society, Columbia University (Dunlap)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July 23</td>
        <td width="76%" class="text">Swords begins printing <span class="textitalic">Wieland</span>
          (Smith)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">September</td>
        <td width="76%" class="text">finishes writing <span class="textitalic">Carwin</span>
          (Dunlap 5 September, 14 September)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">September 19</td>
        <td width="76%" class="text">Smith dies of Yellow Fever</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">September 24</td>
        <td width="76%" class="text">leaves New York for Perth Amboy (Dunlap)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">September 28</td>
        <td width="76%" class="text">brother James visits Brown in Perth
          Amboy (Dunlap)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">October 9-11</td>
        <td width="76%" class="text">walks to Brunswick, NJ</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">October 21</td>
        <td width="76%" class="text">leaves Perth Amboy for Burlington, New Jersey (Dunlap)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">November 15</td>
        <td width="76%" class="text">arrives in New York (Dunlap)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1799</td>
        <td width="24%" class="text">February</td>
        <td width="76%" class="text"><span class="textitalic">Ormond</span>
          published</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">March 30</td>
        <td width="76%" class="text">last issue of <span class="textitalic">Weekly
          Magazine</span></td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">April</td>
        <td width="76%" class="text">first issue of <span class="textitalic">Monthly
          Magazine</span></td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">May</td>
        <td width="76%" class="text"><span class="textitalic">Arthur Mervyn</span>
          Part I published</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">June</td>
        <td width="76%" class="text"><span class="textitalic">Stephen
          Calvert</span> begins serialization in <span class="textitalic">Monthly
            Magazine</span></td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">Summer</td>
        <td width="76%" class="text"><span class="textitalic">Edgar Huntly</span>
          published</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1800</td>
        <td width="24%" class="text">February</td>
        <td width="76%" class="text">John Davis meets Brown in New York
          (Davis I.157)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">March</td>
        <td width="76%" class="text">journey to Connecticut with T.P.
          Cope (Brown 1 April 1801)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">April</td>
        <td width="76%" class="text">first meeting with Elizabeth Linn
          in New York (Brown 23 March 1801)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">Summer</td>
        <td width="76%" class="text"><span class="textitalic">Arthur Mervyn</span>
          Part II published</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">August</td>
        <td width="76%" class="text">returns to Philadelphia (Cope August
          28, Kennedy 1315); partnership with Joseph Brown in family mercantile
          business (Kennedy)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">November</td>
        <td width="76%" class="text">second meeting with Eliza Linn (Brown
          23 March 1801)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">December</td>
        <td width="76%" class="text">last issue of <span class="textitalic">Monthly
          Magazine</span></td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1801</td>
        <td width="24%" class="text">Winter</td>
        <td width="76%" class="text">meets with English actor John Bernard
          to form American version of Covent Garden's &quot;Beefsteak
          Club&quot;</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">March</td>
        <td width="76%" class="text">begins corresponding with Eliza Linn</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">June</td>
        <td width="76%" class="text"><span class="textitalic">Clara Howard</span>
          published</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">June 4</td>
        <td width="76%" class="text">attends fake ventriloquism demonstration
          by Rennie (Cope 62)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">June 23</td>
        <td width="76%" class="text">John Davis meets with Brown (Davis
          II.20)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">June 29</td>
        <td width="76%" class="text">leaves with Cope for New York; lodged
          at Brunswick (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">June 30</td>
        <td width="76%" class="text">arrives in New York, 1 p.m.; CBB
          stays with Johnson (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July 4</td>
        <td width="76%" class="text">Dinner with Cope, Johnson, Dunlap
          "opposite the park" (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July 6</td>
        <td width="76%" class="text">Breakfast with Cope at the Miller's
          (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July 7</td>
        <td width="76%" class="text">sails for Albany with Cope on the
          sloop <span class="textitalic">Harriet</span> (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July 10</td>
        <td width="76%" class="text">arrives at Troy, New York (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July 12</td>
        <td width="76%" class="text">arrives at Albany, 2:00 p.m. (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July 13</td>
        <td width="76%" class="text">leaves for Lebanon, NY (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July 14</td>
        <td width="76%" class="text">CBB writes verse on wall of inn;
          leaves by stage 5 p.m. (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July 15</td>
        <td width="76%" class="text">stops at Northampton, Massachusetts
          (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July 16</td>
        <td width="76%" class="text">leaves by stage for Hartford, CT
          (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July 17</td>
        <td width="76%" class="text">visits R. Alsop at Middletown; arrives
          at New Haven in evening (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July 19</td>
        <td width="76%" class="text">attends sermon on angels by Timothy
          Dwight at Yale College (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July 21</td>
        <td width="76%" class="text">returns to New York; Cope returns
          to Philadelphia the next day, Brown stays with Dunlap (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">October 2</td>
        <td width="76%" class="text">CBB is back in Philadelphia; tea
          with Cope, Bleecker, Irvin (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">October 3</td>
        <td width="76%" class="text">visits alms house, prison, etc.,
          with Cope, Bleecker, Irvin (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">November 30</td>
        <td width="76%" class="text">leaves for New York with Cope (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">December 1</td>
        <td width="76%" class="text">arrives at New York, lodges at Little's
          Hotel (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">December</td>
        <td width="76%" class="text"><span class="textitalic">Jane Talbot</span>
          published; Brown tours Hudson River</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1802</td>
        <td width="24%" class="text">Spring</td>
        <td width="76%" class="text">Grandmother Armitt dies; CBB named
          executor (Krause)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July 3</td>
        <td width="76%" class="text">arrives in New York (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1803</td>
        <td width="24%" class="text">January 20</td>
        <td width="76%" class="text"><span class="textitalic">Cession
          of Louisiana</span> published</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">February 19</td>
        <td width="76%" class="text">agrees to write History of Slavery,
          but never finishes (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">March 3</td>
        <td width="76%" class="text"><span class="textitalic">Monroe's
          Embassy</span> published</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">October</td>
        <td width="76%" class="text">first issue of <span class="textitalic">Literary
          Magazine</span></td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1804</td>
        <td width="24%" class="text">&nbsp;</td>
        <td width="76%" class="text">publishes translation of Volney's
          <span class="textitalic">View of the Soil and Climate of the
            United States</span> with CBB's notes and commentary</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">November 19</td>
        <td width="76%" class="text">marries Elizabeth Linn</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1805</td>
        <td width="24%" class="text">&nbsp;</td>
        <td width="76%" class="text">"Sketch of the Life and Character
          of J. B. Linn" published in Linn's poem <span class="textitalic">Valerian</span></td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July</td>
        <td width="76%" class="text">Dunlap paints portrait of Elizabeth
          Linn Brown (Dunlap)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">August 10</td>
        <td width="76%" class="text">twin sons born, Charles Jr. and William
          Linn Brown </td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1806</td>
        <td width="24%" class="text">&nbsp;</td>
        <td width="76%" class="text">Brown Brothers mercantile firm dissolved</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">January 3</td>
        <td width="76%" class="text">Dunlap paints Charles B. Brown's
          portrait (Dunlap)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">January 6</td>
        <td width="76%" class="text">Dunlap paints second version of Elizabeth
          Brown's portrait (Dunlap)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">March 20</td>
        <td width="76%" class="text">CBB's name proposed to replace Poulson
          as City Librarian (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">March 25</td>
        <td width="76%" class="text">Dunlap stays three weeks with CBB
          (Dunlap 395)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">April 12</td>
        <td width="76%" class="text">CBB withdraws his name from candidacy
          for City Librarian (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">June 12</td>
        <td width="76%" class="text">CBB leaves for Albany to visit his
          in-laws</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">June 16</td>
        <td width="76%" class="text">CBB observes total eclipse</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July</td>
        <td width="76%" class="text">CBB returns home to Philadelphia
          (Dunlap, July 6)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1807</td>
        <td width="24%" class="text">&nbsp;</td>
        <td width="76%" class="text"><span class="textitalic">British
          Treaty of Commerce and Navigation</span> published</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">January</td>
        <td width="76%" class="text">last issue of <span class="textitalic">Literary
          Magazine</span></td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">July 26</td>
        <td width="76%" class="text">son Eugene Linn Brown born</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">October 29</td>
        <td width="76%" class="text">brother Joseph dies in Holland (Krause)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">November</td>
        <td width="76%" class="text">first issue of <span class="textitalic">American
          Register</span></td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1809</td>
        <td width="24%" class="text">&nbsp;</td>
        <td width="76%" class="text">daughter Mary Brown born; publishes
          prospectus for <span class="textitalic">A System of General
            Geography</span></td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">January 3</td>
        <td width="76%" class="text"><span class="textitalic">Address
          to Congress</span> published</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">January 8</td>
        <td width="76%" class="text">Brown's father-in-law William Linn
          dies</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">Summer</td>
        <td width="76%" class="text">convalescent trip to Albany</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">1810</td>
        <td width="24%" class="text">February</td>
        <td width="76%" class="text">last issue of <span class="textitalic">American
          Register</span> published (Dunlap)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">February 15</td>
        <td width="76%" class="text">Cope visits the dying CBB in Philadelphia
          (Cope)</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">February 21</td>
        <td width="76%" class="text">CBB dies in Philadelphia</td>
      </tr>
      <tr align="left" valign="top">
        <td width="24%" class="text">&nbsp;</td>
        <td width="24%" class="text">February 24</td>
        <td width="76%" class="text">CBB's funeral in Philadelphia</td>
      </tr>
    </table>
  </>
)
/*
const ChronologyWorksCited = () => (
    <>
      <p class="subheadbody">Sources for the Biography of Charles Brockden 
            Brown</p>
          <table width="100%" border="1" cellspacing="0" cellpadding="5" bordercolor="#993300">
            <tr> 
              <td width="21%" class="textbold">Short Title</td>
              <td width="79%" class="textbold">Works Cited in Chronology</td>
            </tr>
            <tr> 
              <td width="21%" class="text">Bernard</td>
              <td width="79%" class="text">Bernard, John. <span class="textitalic">Retrospections 
                of America 1797-1811</span>. New York: Harper &amp; Co., 1887; 
                reprint New York: Benjamin Blom, 1969.</td>
            </tr>
            <tr> 
              <td width="21%" class="text">Brown</td>
              <td width="79%" class="text">Charles Brockden Brown, letters, 
                identified by date</td>
            </tr>
            <tr> 
              <td width="21%" class="text">Brown</td>
              <td width="79%" class="text">Bernard, John. <span class="textitalic">Retrospections 
                of America 1797-1811</span>. New York: Harper &amp; Co., 1887; 
                reprint New York: Benjamin Blom, 1969.</td>
            </tr>
            <tr> 
              <td width="21%" class="text">Clark</td>
              <td width="79%" class="text">Clark, David Lee. <span class="textitalic">Charles 
                Brockden Brown: Pioneer Voice of America</span>. Durham, North 
                Carolina: Duke University Press, 1952.</td>
            </tr>
            <tr> 
              <td width="21%" class="text">Cope</td>
              <td width="79%" class="text">Cope, Thomas Pym. <span class="textitalic">Philadelphia 
                Merchant: The Diary of Thomas Pym Cope, 1800-1851.</span> Ed. 
                Eliza Cope Harrison. South Bend, Indiana: Gateway Editions, 
                1978. </td>
            </tr>
            <tr> 
              <td width="21%" class="text">Davis</td>
              <td width="79%" class="text">Davis, John. <span class="textitalic">Travels 
                of Four Years and a Half in the United States of America; during 
                1798, 1799, 1800, 1801, and 1802.</span> London: F. Ostell and 
                T. Hurst and New York: H. Caritat, 1802. Reprint Ed. John Vance 
                Cheney, Boston: Bibliophile Society, 1910.</td>
            </tr>
            <tr> 
              <td width="21%" class="text">Drinker</td>
              <td width="79%" class="text">Henry D. Biddle, ed. <span class="textitalic">Extracts 
                from the Journal of Elizabeth Drinker from 1759 to 1807, A.D.</span> 
                Philadelphia: J.B. Lippincott, 1889.</td>
            </tr>
            <tr> 
              <td width="21%" class="text">Dunlap <span class="textitalic">Gallery</span> 
              </td>
              <td width="79%" class="text">Dunlap, William. &quot;Charles Brockden 
                Brown.&quot; <span class="textitalic">National Portrait Gallery 
                of Distinguished Americans</span>, ed. James Herring and James 
                B. Longacre. Vol. III. New York: M. Bancroft, 1834. </td>
            </tr>
            <tr> 
              <td width="21%" class="text">Dunlap <span class="textitalic">History</span></td>
              <td width="79%" class="text">__________. H<span class="textitalic">istory 
                of the American Theatre</span>. New York: Harper, 1832. </td>
            </tr>
            <tr> 
              <td width="21%" class="text">Dunlap <span class="textitalic">Life</span></td>
              <td width="79%" class="text">_________. <span class="textitalic">Life 
                of Charles Brockden Brown</span>. 2 vols. Philadelphia: James 
                P. Parke, 1815. </td>
            </tr>
            <tr> 
              <td width="21%" class="text">Ferris</td>
              <td width="79%" class="text">Deborah Ferris, Letters to Joseph 
                Bringhurst, Longfellow-Hawthorne Library, Bowdoin College, Brunswick, 
                Maine; see John R. Holmes and Edward Saeger, &quot;Charles Brockden 
                Brown and the 'Laura-Petrarch' Letters,&quot; <span class="textitalic">Early 
                American Literature</span> 25 (1990), 183-186,</td>
            </tr>
            <tr> 
              <td width="21%" class="text">Kafer</td>
              <td width="79%" class="text">Kafer, Peter. &quot;Charles Brockden 
                Brown and Revolutionary Philadelphia: An Imagination in Context.&quot; 
                <span class="textitalic">Pennsylvania Magazine of History and 
                Biography</span> 116 (1992), 467-498.</td>
            </tr>
            <tr> 
              <td width="21%" class="text">Kennedy</td>
              <td width="79%" class="text">Kennedy, Daniel Edwards. &quot;Charles 
                Brockden Brown: His Life and Works.&quot; Unpublished typescript 
                biography written 1922-1960 and now in the C.B. Brown collection 
                at Kent State University, Kent, Ohio.</td>
            </tr>
            <tr> 
              <td width="21%" class="text">Krause</td>
              <td width="79%" class="text">&quot;Chronology&quot; in Syney J. 
                Krause, ed., <span class="textitalic">Three Gothic Novels</span> 
                (New York, Library of America, 1998), 901-907.</td>
            </tr>
            <tr> 
              <td width="21%" class="text">Smith</td>
              <td width="79%" class="text">Smith, Elihu Hubbard. <span class="textitalic">Diary 
                of Elihu Hubbard Smith</span>, ed. James E. Cronin. Philadelphia: 
                American Philosophical Society, 1973. </td>
            </tr>
            <tr> 
              <td width="21%" class="text">Warfel</td>
              <td width="79%" class="text">Warfel, Harry. <span class="textitalic">Charles 
                Brockden Brown: American Gothic Novelist</span>. Gainesville: 
                University of Florida Press, 1949. </td>
            </tr>
            <tr> 
              <td width="21%" class="text">Wilkins</td>
              <td width="79%" class="text">Letters of William Wood Wilkins, 
                University of Virginia</td>
            </tr>
          </table>
          </>
)
*/
export default ChronologyData;